import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './css/Documentary.module.css';
import { Play } from 'lucide-react'; // Lucide play icon

const DocumentaryCard = ({ documentary }) => {
  const navigate = useNavigate();
  const [isClicked, setIsClicked] = useState(false);

  const handleTitleClick = () => {
    setIsClicked(true);
    navigate(`/video/${documentary.slug}`);
  };

  if (!documentary) return null;

  return (
    <div className={`${styles.card} ${isClicked ? styles.clicked : ''}`}>
      <div className={styles.thumbnailContainer}>
        <img
          src={documentary.computer_image_url || documentary.mobile_image_url}
          alt={documentary.title}
          className={styles.thumbnail}
          onClick={handleTitleClick}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/fallback-image.jpg';
          }}
        />
        <div className={styles.playIconWrapper}>
          <Play className={styles.playIcon} />
        </div>
      </div>
    </div>
  );
};

export default DocumentaryCard;
